import Vue from "vue";
import Vuex from "vuex";
import api_client from "../services/api.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    auth: null
  },
  mutations: {
    RESTORE_USER_DATA(state) {
      try {
        const auth = JSON.parse(localStorage.getItem("auth"));
        if (
          auth &&
          Number.isInteger(auth.user_id) &&
          Number.isInteger(auth.user_role)
        ) {
          state.auth = auth;
          return;
        }
      } catch (error) {
        // An invalid saved session should show the login page, not break layout.
      }
      localStorage.removeItem("auth");
      state.auth = null;
    },

    SET_USER_DATA(state, auth) {
      localStorage.setItem("auth", JSON.stringify(auth));
      state.auth = auth;
    },

    LOGOUT(state) {
      localStorage.removeItem("auth");
      state.auth = null;
      location.reload();
    }
  },

  actions: {
    login({ commit }, credentials) {
      return api_client.auth(credentials).then(({ data }) => {
        commit("SET_USER_DATA", data);
      });
    },
    
    logout({ commit }) {
      commit("LOGOUT");
      return api_client.logout();
    }
  },

  getters: {
    is_admin: state => Boolean(state.auth && state.auth.user_role === 0),

    sidebar_menu: (state, getters) => {
      if (!state.auth) {
        return [{ href: "/login", title: "Login", icon: "mdi mdi-login" }];
      }

      const menu = [
        { href: "/licenses", title: "Perpetual Licenses", icon: "mdi mdi-key" },
        {
          href: "/licenses_v3",
          title: "Subscription Licenses",
          icon: "mdi mdi-calendar-check"
        },
        {
          href: "/subscriptions_v3",
          title: "Subscriptions",
          icon: "mdi mdi-calendar-range"
        },
        { href: "/settings", title: "Settings", icon: "mdi mdi-cog" }
      ];

      // Omit the entire Admin group for customers, including its child links.
      if (getters.is_admin) {
        menu.push({
          title: "Admin",
          icon: "mdi mdi-shield-account",
          child: [
            { href: "/admin/licenses_v3", title: "Subscription Licenses" },
            { href: "/admin/subscriptions_v3", title: "Subscriptions" },
            { href: "/admin/br_releases", title: "BR Releases" }
          ]
        });
      }

      menu.push({ href: "/logout", title: "Logout", icon: "mdi mdi-logout" });
      return menu;
    }
  }
});
